import { gql } from "apollo-boost";


export const GET_EXAM_QUESTION = gql`
  query getExamQuestion($id : ID!){
    getExamQuestion (
      id: $id
    )
    {
      id
      subject {
        id
        nameLocal
      }
      subjectCode
      teacher {
        id picturePath
      }
      teacherCode
      courseOutlineUnit { id }
      unitSeq
      questionType {
        id
        code
        nameLocal
        nameEng
      }
      questionTypeCode
      nameLocal
      nameEng
      score
      picturePath
      isRandomChoice
      isActive
      examAnswers {
        id
        no
        isCorrected
        nameLocal
        nameEng
        picturePath
        isDisabled
      }
    }
  }
`;
export const CHECK_CAN_UPDATE_OR_DELETE = gql`
  query checkCanUpdateOrDeleteExamQuestion($id : ID!){
    checkCanUpdateOrDeleteExamQuestion (
      id: $id
    )
  }
`;

export const GET_EXAMQUESTION_LIST_BY_FILTER = gql`
  query getExamQuestionsByFilter (
    $examQuestionsFilterInput: ExamQuestionFilterInput
  ) {
    getExamQuestionsByFilter (
      examQuestionsFilterInput: $examQuestionsFilterInput
    )
    {
      id
      subject {
        id
        nameLocal
      }
      subjectCode
      teacher {
        id picturePath
      }
      teacherCode
      unitSeq
      questionTypeCode
      nameLocal
      nameEng
      score
      isRandomChoice
      # questionType {
      #   code
      #   nameLocal
      #   nameEng
      # }
      examAnswers {
        id
      }
    }
  }
`;

export const GET_EXAM_QUESTIONS_PAGINATION = gql`
  query examQuestionsPagination(
    $filter: String
    $where: ExamQuestionFilterInput
    $pageSize: Int
    $currentPage: Int
    $orderBy: ExamQuestionsOrderByInput!) {
    examQuestionsPagination(
      filter: $filter
      where: $where
      pageSize: $pageSize
      currentPage: $currentPage
      orderBy: $orderBy
    ) {
      nodes {
        id
        subject {
          id
          nameLocal
        }
        subjectCode
        teacher {
          id picturePath
        }
        teacherCode
        courseOutlineUnit { id }
        unitSeq
        questionType {
          id
          code
          nameLocal
          nameEng
        }
        questionTypeCode
        nameLocal
        nameEng
        score
        picturePath
        isRandomChoice
        isActive
        examAnswers {
          id
          no
          isCorrected
          nameLocal
          nameEng
          picturePath
        }
      }
      pageInfo {
        fromItem
        toItem
        currentPage
        pageSizes
        totalItemsInPage
        totalPage
        totalItems
      }
    }
  }
`;

export const ADD_EXAM_QUESTION = gql`
  mutation addExamQuestion(
    $examId: ID!
    $subjectId: ID!
    $teacherId: ID!
    $questionTypeId: ID!
    $courseOutlineUnitId: ID!
    $examQuestionInput: ExamQuestionInput!
    $examAnswersInput: [ExamAnswerInput]
  ) {
    addExamQuestion(
      examId: $examId
      subjectId: $subjectId
      teacherId: $teacherId
      questionTypeId: $questionTypeId
      courseOutlineUnitId: $courseOutlineUnitId
      examQuestionInput: $examQuestionInput
      examAnswersInput: $examAnswersInput
    ) {
      id
      subject {
        id
        nameLocal
      }
      subjectCode
      teacher {
        id picturePath
      }
      teacherCode
      courseOutlineUnit { id }
      unitSeq
      questionType {
        id
        code
        nameLocal
        nameEng
      }
      questionTypeCode
      nameLocal
      nameEng
      score
      picturePath
      isRandomChoice
      isActive
      examAnswers {
        id
        no
        isCorrected
        nameLocal
        nameEng
        picturePath
      }
    }
  }
`;

export const UPDATE_EXAM_QUESTION = gql`
  mutation updateExamQuestion(
    $id: ID!,
    $questionTypeId: ID!
    $courseOutlineUnitId: ID!
    $examQuestionInput: ExamQuestionInput!
    $examAnswersInput: [ExamAnswerInput]
  ) {
    updateExamQuestion(
      id: $id
      questionTypeId: $questionTypeId
      courseOutlineUnitId: $courseOutlineUnitId
      examQuestionInput: $examQuestionInput
      examAnswersInput: $examAnswersInput
    ) {
      id
      subject {
        id
        nameLocal
      }
      subjectCode
      teacher {
        id picturePath
      }
      teacherCode
      courseOutlineUnit { id }
      unitSeq
      questionType {
        id
        code
        nameLocal
        nameEng
      }
      questionTypeCode
      nameLocal
      nameEng
      score
      picturePath
      isRandomChoice
      isActive
      examAnswers {
        id
        no
        isCorrected
        nameLocal
        nameEng
        picturePath
      }
    }
  }
`;

export const DELETE_EXAM_QUESTION = gql`
  mutation deleteExamQuestion($id: ID!) {
    deleteExamQuestion(
      id: $id
    ) {
      id
      subject {
        id
        nameLocal
      }
      subjectCode
      teacher {
        id picturePath
      }
      teacherCode
      courseOutlineUnit { id }
      unitSeq
      questionType {
        id
        code
        nameLocal
        nameEng
      }
      questionTypeCode
      nameLocal
      nameEng
      score
      picturePath
      isRandomChoice
      isActive
      examAnswers {
        id
        no
        isCorrected
        nameLocal
        nameEng
        picturePath
      }
    }
  }
`;


export const DELETE_ALL_EXAM_QUESTION = gql`
  mutation deleteAllExamQuestion($subjectId: ID!, $teacherId: ID!) {
    deleteAllExamQuestion(
      subjectId: $subjectId
      teacherId: $teacherId
    ) {
      success
      deletedQty
    }
  }
`;
